import { connect } from 'react-redux';
import compose from 'recompose/compose';

import AudienceCount from '../components/AudienceCount';
import { withBarberType } from '../../../modules/barber/barber-type/with-barber-type';
import { isBarberUser } from '../../auth/selectors';

const AudienceCountContainer = compose(
  withBarberType,
  connect(
    (state, ownProps) => ({
      audienceCount: state.engagement.campaign.totalCustomersNotified,
      canSendSms: !isBarberUser(state) || ownProps.barberType !== 'studio',
    })
  ),
)(AudienceCount);

export default AudienceCountContainer;
